import FingerprintJS from '@fingerprintjs/fingerprintjs'

import { isBrowser } from '@app/utils/isBrowser'
import { segmentSSR } from './segmentSSR'

const getAnalytics = () =>
  // @ts-ignore
  analytics?.Integrations
    ? {
        type: 'analytics-js',
        instance: analytics
      }
    : {
        type: 'analytics-node',
        instance: segmentSSR
      }

export const getFingerPrintId = async () => {
  const fp = await FingerprintJS.load()
  const result = await fp.get()
  return result.visitorId
}

export const identifySegment = async (sessionId: string) => {
  if (!isBrowser) {
    return
  }

  const fingerPrintId = await getFingerPrintId()
  getAnalytics().instance?.identify(sessionId, {
    fingerPrintId: fingerPrintId
  })
}

export const trackSegmentEvent = async (
  sessionId: string,
  eventName: string,
  properties?: any,
  callback?: () => void
) => {
  if (eventName && isBrowser) {
    const fingerPrintId = await getFingerPrintId()
    getAnalytics().instance?.track(
      eventName,
      {
        userId: sessionId,
        fingerPrintId: fingerPrintId,
        ...properties
      },
      callback
    )
  }
}

export const segmentEventsNames = {
  HOME_PAGE_VIEW: 'Home Page View',
  ABA_THERAPY_VIEW: 'ABA Therapy View',
  AUTISM_DIAGNOSIS_VIEW: 'Autism Diagnosis View',
  OUR_PROVIDERS_VIEW: 'Our Providers View',
  FAQ_VIEW: 'FAQ View',
  LOCATIONS_STATE_VIEW: 'Locations State View',
  LEARNING_STUDIO_VIEW: 'Learning Studio View',
  COST_CALCULATOR_PERSONAL_INFO_VIEW: 'Cost Calculator Personal Info View',
  FOR_PROVIDERS_VIEW: 'For Providers View', // on the web site now it is For ABA Clinicians
  CONTACT_US_VIEW: 'Contact Us View',
  FOR_PEDIATRICIANS_VIEW: 'For Pediatricians View',
  OUR_STORY_VIEW: 'Our Story View',
  LOCATIONS_MAIN_VIEW: 'Locations Main View',
  NBC_VIDEO_CLICK: 'NBC Video Click',
  PARENT360_LOG_IN: 'Parent360 Log In',
  FOR_PEDIATRICIANS_REFER_CLICK: 'For Pediatricians - Refer Click',
  CONTACT_INQUIRIES_CLICK: 'Contact Inquiries Click',
  FOR_PROVIDERS_APPLY_NOW: 'For Providers - Apply Now', // on the web site now it is For ABA Clinicians
  CAREERS_VIEW: 'Careers View',
  CAREERS_EXPLORE_CLICK: 'Careers - Explore Click',
  LOCATIONS_CITY_VIEW: 'Locations City View',
  COST_CALCULATOR_COST_ESTIMATE_VIEW: 'Cost Calculator Cost Estimate View',
  GET_STARTED_CLICK: 'Get Started Click',

  // booking
  BOOKING_FLOW_STARTED: 'Booking Flow Started',
  BOOKING_FLOW_POSTAL_CODE_COMPLETED: 'Booking Flow Postal Code Completed',
  BOOKING_FLOW_AGE_COMPLETED: 'Booking Flow Age Completed',
  BOOKING_FLOW_DIAGNOSIS_COMPLETED: 'Booking Flow Diagnosis Completed',
  BOOKING_FLOW_INSURANCE_COMPLETED: 'Booking Flow Insurance Completed',
  BOOKING_FLOW_CALL_REQUESTED: 'Booking Flow Call Requested',
  BOOKING_FLOW_CALL_SCHEDULED: 'Booking Flow Call Scheduled',
  BOOKING_FLOW_COMPLETED: 'Booking Flow Completed',
  BOOKING_FLOW_ADDED_TO_CALENDAR: 'Booking Flow Add to calendar Scheduled Call',
  BOOKING_FLOW_NOT_QUALIFIED_VIEW: 'Not qualified view - booking flow',
  BOOKING_FLOW_NOT_QUALIFIED_CONTACT_SUBMIT: 'Booking Flow Not Qualified Contact Submit'
}
